module.exports = __webpack_public_path__ + "static/img/p2.6c88e90c.png";